export type DiagramUnivers =
  | 'Talents'
  | 'Carrières'
  | 'Santé'
  | 'Éducation'
  | 'Vie Perso'
  | 'Générique';

export type DiagramUniversOption = {
  value: DiagramUnivers;
  label: string;
  swatchColor: string;
};

export const DEFAULT_DIAGRAM_COLORS = [
  '#071B45',
  '#212E57',
  '#374368',
  '#4D597A',
  '#636E8B',
  '#808AA3',
  '#969FB3',
  '#ACB4C2',
  '#C0C5CF',
  '#D4D7DD',
];

export const getDefaultDiagramTextColor = (color: string, fallback: string) => {
  const level = DEFAULT_DIAGRAM_COLORS.indexOf(color.toUpperCase());
  return level < 0 ? fallback : level < 5 ? '#FFFFFF' : '#000B33';
};

export const DIAGRAM_UNIVERS_PALETTES: Record<DiagramUnivers, string[]> = {
  Talents: ['#aaa3cc', '#7f75cc', '#5e4cb0', '#473d96', '#39317c', '#240751'],
  Carrières: ['#e9928b', '#e2665a', '#d34634', '#b83427', '#90231c', '#601210'],
  Santé: ['#7eddd7', '#4bccc8', '#24bab9', '#21a49f', '#1c847d', '#135e59'],
  Éducation: ['#a6cdf4', '#7ab1f2', '#5e97f1', '#4983d5', '#2a659f', '#1a4568'],
  'Vie Perso': ['#e19db4', '#cc6986', '#b3405f', '#9b3354', '#7a2141', '#5b1432'],
  Générique: ['#9198f3', '#6e75de', '#4d55c4', '#2a32a3', '#000a8d', '#000b33'],
};

export const DIAGRAM_UNIVERS_OPTIONS: DiagramUniversOption[] = [
  { value: 'Talents', label: 'Talents', swatchColor: '#5e4cb0' },
  { value: 'Carrières', label: 'Carrières', swatchColor: '#d34634' },
  { value: 'Santé', label: 'Santé', swatchColor: '#24bab9' },
  { value: 'Éducation', label: 'Éducation', swatchColor: '#5e97f1' },
  { value: 'Vie Perso', label: 'Vie perso', swatchColor: '#b3405f' },
  { value: 'Générique', label: 'Générique', swatchColor: '#000b33' },
];

export const getDiagramUniversOption = (univers?: DiagramUnivers | string | null) =>
  DIAGRAM_UNIVERS_OPTIONS.find(option => option.value === univers) ?? null;

export const getDiagramUniversPalette = (univers?: DiagramUnivers | string | null): string[] => {
  if (univers && univers in DIAGRAM_UNIVERS_PALETTES) {
    return DIAGRAM_UNIVERS_PALETTES[univers as DiagramUnivers];
  }

  return [...DEFAULT_DIAGRAM_COLORS].reverse();
};

/** How palette colors are assigned by rank (rank 0 = highest value). */
export type DiagramUniversColorOrder = 'lightToDark' | 'darkToLight';

export const getDiagramUniversColorForRank = (
  univers: DiagramUnivers | string | null | undefined,
  rank: number,
  colorOrder: DiagramUniversColorOrder = 'lightToDark'
): string => {
  const palette = getDiagramUniversPalette(univers);
  const safeRank = rank % palette.length;

  if (colorOrder === 'darkToLight') {
    return palette[palette.length - 1 - safeRank];
  }

  return palette[safeRank];
};
